import { h, render } from 'preact';

import pendingPromise from 'utils/pendingPromise';

import { replacePlaylistWithVideos } from 'utils/videos';
import { getYoutubeId, getYoutubePlaylistId } from './assets';
import { getVideoData } from 'services/youtubeApi';

import TrailerModal from 'components/trailerModal/trailerModal';

export async function showTrailerModal(trailers, data) {
	// if (!data) return;

	// Let the browser paint before rendering, to improve INP
	await new Promise(r => setTimeout(r, 0));

	const container = document.createElement('div');
	render(<TrailerModal data={data} trailers={trailers || [data?.trailer?.url]} />, container);

	const dialog = container.firstElementChild;
	if (!dialog || dialog.tagName !== 'DIALOG') {
		throw new Error('No dialog element from TrailerModal');
	}

	const promise = pendingPromise();

	dialog.addEventListener('cancel', () => promise.resolve(null));
	dialog.addEventListener('close', () => promise.resolve(dialog.returnValue));

	document.body.append(dialog);
	dialog.showModal();

	let result = await promise;

	// Wait for potential exit transitions before removing from the dom
	allTransitionsEnded(dialog).then(() => dialog.remove());

	return result;
}

function allTransitionsEnded(node) {
	return Promise.allSettled(node.getAnimations().map(animation => animation.finished));
}

export async function transformVideosList(trailersList) {
	// supports youtube only for now
	const list = await Promise.all(trailersList.map(async (vid) => {
		// Handle both string URLs (legacy) and objects with url/thumbnail (new format)
		const vidUrl = typeof vid === 'string' ? vid : vid?.url;
		const customThumbnail = typeof vid === 'object' ? vid?.thumbnail : null;
		const customTitle = typeof vid === 'object' ? vid?.title : null;
		const thumbnailAlt = typeof vid === 'object' ? vid?.thumbnailAlt : null;

		const vidData = {
			key: '',
			name: '',
			thumbSrc: '',
			thumbAlt: ''
		};
		const ytPlaylist = getYoutubePlaylistId(vidUrl);
		if (ytPlaylist) {
			vidData.youtubePlaylistId = ytPlaylist;
			vidData.key = `playlist-${ytPlaylist}`;
			return vidData;
		}
		const ytId = getYoutubeId(vidUrl);
		if (ytId) {
			vidData.youtubeId = ytId;
			const ytData = await getVideoData(ytId);
			if (!ytData?.items?.length) return;
			const video = ytData.items[0];
			vidData.key = `video-${ytId}`;
			// Use custom title/thumbnail if available, otherwise fall back to YouTube data
			vidData.name = customTitle || video?.snippet?.title || '';
			vidData.thumbSrc = customThumbnail || video?.snippet?.thumbnails?.medium?.url || '';
			vidData.thumbAlt = thumbnailAlt || `Thumbnail for ${vidData.name}`;
		}
		return vidData;
	}).filter(x => x));

	return await replacePlaylistWithVideos(list);
}